// extracted by mini-css-extract-plugin
export default {"root":"arNYJZHCeUsZRryX8tuE","collapseButton":"XwxfOR3L_sLRLRdsGnQq","hasCollapsedText":"nlbjMv8mqoFHePBnsvR0"};